import { savedCompetitionSelection } from '../../../services/hooks/Registration/registrationCompetition';
import {
  Accordion,
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Td,
  Text,
  Textarea,
  Tooltip,
  Tr,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import MainCard from '../../../components/MainCard/Index';
import { useLocation, useNavigate } from 'react-router-dom';
import { useContext, useEffect, useMemo, useState } from 'react';
import { ContextAuth } from '../../../contexts/Authentication';
import { yupResolver } from '@hookform/resolvers/yup';
import AccordionTemplate from '../../../components/AccordionTemplate/Index';
import { useRequestGetDataToRegistration } from '../../../services/hooks/CandidateArea/useGetDataToRegistration';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import MessageError from '../../../components/MessageError';
import { useCreateRegistration } from '../../../services/hooks/Registration/usePostRegistration';
import VacancyCutureHome from '../../../components/pages/Registration/CultureHousesVacancy';
import DefaultVacancyForm, { ETypeOfCompetition } from '../../../components/pages/Registration/DefaultVacancy';
import { TextL, TextXS, TextXXS, TextS } from '../../../components/Text/Index';
import { useRequestSelectiveProcessVacancy } from '../../../services/hooks/SelectiveProcess/useRequestSelectiveProcessVacancy';
import { IGetRegistration, useGetRegistration } from '../../../services/hooks/Registration/useGetRegistration';
import { useUpdateRegistration } from '../../../services/hooks/Registration/useUpdateRegistration';
import { useVerifyExemptionStandBy } from '../../../services/hooks/CandidateArea/useVerifyExemptionStandBy';
import MessageForUser from '../../../components/pages/SelectiveProcess/MessageForUser';
import TableCustom from '../../../components/pages/CandidateArea/Table';
import { handleDeleteAttach } from '../../../utils/functions';
import { IoTrash } from 'react-icons/io5';
import CreateRegistrationMobilePage, { ERegistrationType } from './Mobile';
import { shapeFormRegistration } from './utils';
import { UseRegistration } from '../../../Store/useRegistration';
import { useRequestGetExemptionType } from '../../../services/hooks/Exemptions/useRequestGetExemptionType';

const SelectiveProcessSubscribe: React.FC = () => {
  // Query params
  const selectiveProcessId = useLocation().pathname.split('/')[2];
  const registrationId = useLocation().pathname.split('/')[4];

  // States
  const { onResetRegistration, setRegistrationId, setSelectiveProcessId } = UseRegistration();

  const [attachToDeletId, setAttachToDeleteId] = useState<string>('');

  // Request
  const VerifyExemptionStandBy = useVerifyExemptionStandBy(selectiveProcessId);
  const selectiveProcessData = useRequestGetDataToRegistration(selectiveProcessId);
  const vacancy = useRequestSelectiveProcessVacancy(
    selectiveProcessId,
    selectiveProcessData.data?.is_cultural_house || false,
  );
  const { isPending, mutateAsync } = useCreateRegistration();
  const registrationData = useGetRegistration(registrationId);
  const updateRegistration = useUpdateRegistration();
  const attachSpecialCondition = ['Arquivo', 'Data de envio', 'Ações'];
  const getExemption = useRequestGetExemptionType(selectiveProcessId);

  // Hooks
  const navigate = useNavigate();
  const { signOut, candidate, isMobile } = useContext(ContextAuth);
  const toast = useToast();
  const modal = useDisclosure();

  useEffect(() => {
    if (registrationData.data?.second_vacancy) {
      hookForms.setValue('has_second_vacancy', true);
    } else {
      hookForms.setValue('has_second_vacancy', false);
    }

    if (registrationData?.data?.juror_art_440_cpp) {
      hookForms.setValue('juror_art_440_cpp', 'yes');
    } else {
      hookForms.setValue('juror_art_440_cpp', 'no');
    }

    if (registrationData.data?.according_to_the_terms) {
      hookForms.setValue('terms', registrationData.data?.according_to_the_terms);
    }

    if (registrationData.data?.according_to_the_terms) {
      hookForms.setValue('terms', registrationData.data?.according_to_the_terms);
    }
  }, [registrationData.data]);

  useEffect(() => {
    setRegistrationId(registrationId);
    setSelectiveProcessId(selectiveProcessId);

    return () => {
      onResetRegistration();
    };
  }, []);

  const listCheckedSpecialCondition: (string | boolean)[] = [];
  const listObservationSpecialCondition: (string | boolean | undefined)[] = [];

  const listCheckedProtocol: (string | boolean)[] = [];
  const listSocialNameProtocol: (string | boolean | undefined)[] = [];

  selectiveProcessData.data?.special_condition.map((s) => {
    let isSelected = false;
    let obs = '';
    // let sName = '';

    registrationData.data?.special_conditions.forEach((r) => {
      if (r.id === s.id) {
        isSelected = true;
        obs = r.observations;
        // sName = r?.social_name;
      }
    });

    if (isSelected) {
      listCheckedSpecialCondition.push(s.id);
      listObservationSpecialCondition.push(obs);
      // listSocialName.push(sName);
    } else {
      listCheckedSpecialCondition.push(false);
      listObservationSpecialCondition.push('');
      // listSocialName.push(undefined);
    }
  });

  selectiveProcessData?.data?.protocol?.map((s) => {
    let isSelected = false;
    let sName = '';

    registrationData.data?.protocol.forEach((r) => {
      if (r.protocol_type.id === s.id) {
        isSelected = true;
        sName = r?.social_name;
      }
    });

    if (isSelected) {
      listCheckedProtocol.push(s.id);
      listSocialNameProtocol.push(sName);
    } else {
      listCheckedProtocol.push(false);
      listSocialNameProtocol.push(undefined);
    }
  });

  const hasFullVacancy = savedCompetitionSelection(registrationData.data?.type_of_competition);

  const savedTypeOfCompetitionId = registrationData.data?.type_of_competition?.find((item) => {
    const normalizedName = item.name.toLowerCase().replace(/[-_]/g, ' ');
    if (hasFullVacancy === ETypeOfCompetition.FULL_VACANCY) return normalizedName.includes('ampla');
    if (hasFullVacancy === ETypeOfCompetition.UFC_SERVER_VACANCY) return normalizedName.includes('ufc');
    return false;
  })?.id;

  const pcdDetails = registrationData.data?.reserved_vacancy.find((reserved) =>
    reserved.type.toLowerCase().includes('pcd'),
  );

  const pcdId = useMemo(
    () => getExemption.data?.find((exemption) => exemption.name.toLowerCase().includes('pcd'))?.id,
    [getExemption.data],
  );

  const savedVacancy = vacancy.data?.find(
    (item) => item.id === registrationData.data?.selective_process_vacancy?.id,
  );

  const schema = shapeFormRegistration({
    listVacancy: vacancy.data,
    navigate,
    registration: registrationData.data,
    selectiveProcess: selectiveProcessData.data,
    toast,
  });

  const hookForms = useForm({
    resolver: yupResolver(schema),
    context: {
      vacancyList: vacancy.data || [],
      registrationId,
      selectiveProcessId,
      pcdId,
    },
    values: {
      vacancy: registrationData.data?.selective_process_vacancy?.id,
      type_of_competition: registrationData.data?.type_of_competition.length === 0 ? '' : hasFullVacancy,
      type_of_competition_id: savedTypeOfCompetitionId ?? '',
      has_special_condition:
        (registrationData.data?.special_conditions &&
          (registrationData.data.special_conditions.length > 0 ? 'yes' : 'no')) ||
        '',
      has_protocol:
        (registrationData.data?.protocol && (registrationData.data.protocol.length > 0 ? 'yes' : 'no')) || '',
      culture_home: registrationData.data?.selective_process_vacancy?.cultural_house || '',
      has_second_vacancy: registrationData.data?.second_vacancy ? true : false,
      culture_home_secondary: registrationData.data?.second_vacancy?.cultural_house,
      weapon_carry_permit: registrationData.data?.has_gun_license,
      initial_semester_secondary: registrationData.data?.second_vacancy?.id,
      juror_art_440_cpp: registrationData.data?.juror_art_440_cpp ? 'yes' : 'no',
      allow_filter_vacancy_tree:
        registrationData.data?.selective_process_vacancy.level?.id || savedVacancy?.level?.id || '',
      research_line: registrationData.data?.selective_process_vacancy.research_line || '',
      thematic_axis: registrationData.data?.selective_process_vacancy.thematic_axis || '',
      selectedSpecialCondition: listCheckedSpecialCondition,
      observation: listObservationSpecialCondition,
      selectedProtocol: listCheckedProtocol,
      social_name_protocol: listSocialNameProtocol,
      cid: pcdDetails?.cid,
      deficiency: pcdDetails?.deficiency,
      sub_type_of_competition: registrationData.data?.sub_types_of_competitions?.flatMap((item) => item.id) ?? [],
      modality_type:
        registrationData.data?.type_of_competition?.filter((competition) => !/ampla|ufc/i.test(competition.name)).map((competition) =>
          isMobile ? competition.id : JSON.stringify({ id: competition.id, name: competition.name }),
        ) || undefined,
      terms:
        registrationData.data?.according_to_the_terms ||
        (selectiveProcessData.data?.display_terms_acceptance_before_registration
          ? sessionStorage.getItem('acceptTerms') === 'true' && true
          : false),

      eligibility_declaration: registrationData.data?.eligibility_declaration,
    },
  });

  const selectVacancy = useMemo(() => {
    const vacancyId = hookForms.watch('vacancy');
    if (vacancy?.data) {
      return vacancy?.data?.find((vac) => vacancyId === vac?.id);
    }

    return undefined;
  }, [vacancy?.data, hookForms.watch('vacancy')]);

  const patchRegistration = async (data: FieldValues, oldData?: IGetRegistration | null, deleteAtach?: boolean) => {
    updateRegistration
      .mutateAsync({
        data,
        selectiveProcess: selectiveProcessData.data,
        listTypeCompetition: vacancy.data,
        registrationId: registrationId,
        exemptionRegistrationId: VerifyExemptionStandBy?.data?.id,
        oldData: oldData,
      })
      .then((response) => {
        if (deleteAtach) {
          return;
        }
        if (registrationId) {
          toast({
            title: 'Sucesso',
            description: registrationId ? 'Inscrição atualizada com sucesso!' : 'Inscrição realizada com sucesso!',
            status: 'success',
            duration: 4000,
            isClosable: true,
          });
          navigate('/painel/inscricoes');
        } else {
          toast({
            title: 'Sucesso',
            description: registrationId ? 'Inscrição atualizada com sucesso!' : 'Inscrição realizada com sucesso!',
            status: 'success',
            duration: 4000,
            isClosable: true,
          });
          const nextRoute = selectiveProcessData.data?.allow_filter_vacancy_tree
            ? `/processo-seletivo/${selectiveProcessId}/inscricao/${response?.id}/documentos-vaga?standbyExemption=true`
            : `/processo-seletivo/${selectiveProcessId}/inscricao/${response?.id}/resumo?previous-route=/processo-seletivo/inscricao&standbyExemption=true`;
          navigate(nextRoute);
        }
      })
      .catch((error) => {
        toast({
          title: 'Atenção',
          description: error.response?.data.message || 'Erro na solicitação, tente novamente mais tarde',
          status: 'warning',
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const postRegistration = async (data: FieldValues) => {
    mutateAsync({
      data,
      selectiveProcess: selectiveProcessData.data,
      listTypeCompetition: vacancy.data,
    })
      .then((response) => {
        toast({
          title: 'Sucesso',
          description: 'Inscrição criada com sucesso!',
          status: 'success',
          duration: 4000,
          isClosable: true,
        });
        const nextRoute = selectiveProcessData.data?.allow_filter_vacancy_tree
          ? `/processo-seletivo/${selectiveProcessId}/inscricao/${response?.id}/documentos-vaga`
          : `/processo-seletivo/${selectiveProcessId}/inscricao/${response?.id}/resumo?previous-route=/processo-seletivo/inscricao`;
        navigate(nextRoute);
      })
      .catch((error) => {
        toast({
          title: 'Atenção',
          description: error.response?.data.message || 'Não foi possivel realizar a inscrição.',
          status: 'warning',
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const newRegistration = (data: FieldValues) => {
    if (
      data.type_of_competition === ETypeOfCompetition.FULL_VACANCY ||
      data.type_of_competition === ETypeOfCompetition.UFC_SERVER_VACANCY
    ) {
      const isFullVacancy = data.type_of_competition === ETypeOfCompetition.FULL_VACANCY;
      const selectedType = selectVacancy?.type_of_competition?.find((type) => {
        const normalizedName = type.name.toLowerCase().replace(/[-_]/g, ' ');
        return isFullVacancy ? normalizedName.includes('ampla') : normalizedName.includes('ufc');
      });

      if (selectedType) {
        data = {
          ...data,
          type_of_competition: selectedType.id,
          type_of_competition_id: selectedType.id,
          is_all: true,
        };
      }
    }

    if (VerifyExemptionStandBy?.data) {
      if (VerifyExemptionStandBy?.data.selective_process_vacancy && selectiveProcessData?.data && !registrationId) {
        postRegistration(data);
      } else if (selectiveProcessData.data) {
        patchRegistration(data, registrationData?.data);
      }
    } else if (registrationId && selectiveProcessData?.data) {
      patchRegistration(data, registrationData.data);
    } else if (selectiveProcessData?.data) {
      postRegistration(data);
    }
  };

  const renderFilenameProtocol = (idx: number) => {
    const files: FileList = hookForms.watch(`protocol_attachmentFile.${idx}`);
    const listFileName: string[] = [];

    if (!files || files.length === 0) {
      return ['Envie seus arquivos'];
    } else {
      for (let index = 0; index < files.length; index++) {
        listFileName.push(files[index]?.name || 'Sem_nome');
      }
    }

    return listFileName;
  };

  const renderFilenameProtocolPhoto = (idx: number) => {
    const files: FileList = hookForms.watch(`protocol_photo.${idx}`);
    const listFileName: string[] = [];

    if (!files || files.length === 0) {
      return ['Envie seus arquivos'];
    } else {
      for (let index = 0; index < files.length; index++) {
        listFileName.push(files[index]?.name || 'Sem_nome');
      }
    }

    return listFileName;
  };

  const renderFilename = (idx: number) => {
    const files: FileList = hookForms.watch(`attachmentFile.${idx}`);
    const listFileName: string[] = [];

    if (!files || files.length === 0) {
      return ['Envie seus arquivos'];
    } else {
      for (let index = 0; index < files.length; index++) {
        listFileName.push(files[index]?.name || 'Sem_nome');
      }
    }

    return listFileName;
  };

  const deleteAttachment = async (fileId: string) => {
    await handleDeleteAttach(fileId, toast, registrationData.refetch).then(() => {});
  };

  const deleteProtocolAttach = async (fileId: string) => {
    await handleDeleteAttach(fileId, toast, registrationData.refetch).then(() => {
      modal.onClose();
    });
  };

  if (selectiveProcessData?.data && !selectiveProcessData?.data?.allows_foreigners && candidate?.is_foreign) {
    navigate('/');
  }

  if (isMobile)
    return (
      <FormProvider {...hookForms}>
        <CreateRegistrationMobilePage
          sendingForm={isPending || updateRegistration.isPending}
          registrationType={ERegistrationType.ONLY_REGISTRATION}
          onSubmitForm={newRegistration}
          modalityAvailable={selectVacancy?.type_of_competition}
          isLoading={isPending || updateRegistration.isPending}
        />
      </FormProvider>
    );

  return (
    <FormProvider {...hookForms}>
      <MainCard
        title="PROCESSO SELETIVO - "
        subtitle={registrationId ? 'MODIFICAR DADOS DA INSCRIÇÃO' : 'FORMULÁRIO DE INSCRIÇÃO'}
      >
        <Flex
          as="form"
          onSubmit={hookForms.handleSubmit(newRegistration)}
          flexDir="column"
          px={['10px', '10px', '10px', '50px', '50px']}
          gap={10}
        >
          {selectiveProcessData?.data?.registration_confirmation && (
            <MessageForUser mt={5} informationText={selectiveProcessData?.data?.registration_confirmation || ''} />
          )}
          <Flex
            justifyContent="space-between"
            alignItems="left"
            flexDir={['column', 'column', 'column', 'row', 'row']}
            overflow="hidden"
          >
            <Stack color="darkGrey">
              <TextXS>{selectiveProcessData.data?.selective_process_type_name || ''}</TextXS>
              <TextL>{selectiveProcessData.data?.name || ''}</TextL>
            </Stack>
          </Flex>
          <Stack>
            <Accordion display="flex" flexDir="column" gap={2} allowMultiple defaultIndex={[0, 1, 2, 3, 4]}>
              <AccordionTemplate title="DADOS PESSOAIS" border="1px solid" borderColor="primaryColor" borderRadius={6}>
                <Flex px={10} mb={5} flexDir={['column', 'column', 'row', 'row', 'row']}>
                  <Stack w="100%" p={3}>
                    <TextXS>
                      <strong>Nome Completo:</strong> {candidate?.user?.full_name || '--'}
                    </TextXS>
                    {candidate?.social_name && (
                      <TextXS>
                        <strong>Nome social: </strong>
                        {candidate?.social_name || '--'}
                      </TextXS>
                    )}
                    <Stack gap={0}>
                      <TextXS>
                        <strong>{candidate?.is_foreign ? 'Passaporte' : 'CPF'}:</strong>{' '}
                        {candidate?.is_foreign ? candidate?.passport_number : candidate?.cpf || '--'} <br />
                      </TextXS>

                      <TextXXS ml="30px" as={'span'}>
                        Não é seu {candidate?.is_foreign ? 'passaporte?' : 'CPF?'}{' '}
                        <Link
                          onClick={() => {
                            signOut();
                            navigate('/');
                          }}
                          as={'span'}
                          color="colorLink"
                        >
                          clique aqui
                        </Link>
                      </TextXXS>
                    </Stack>
                    <TextXS>
                      <strong>Data de nascimento:</strong> {candidate?.date_of_birth.br || '--'}
                    </TextXS>
                    <TextXS>
                      <strong>E-mail:</strong> {candidate?.user?.email || '--'}
                    </TextXS>
                    {!candidate?.is_foreign && (
                      <TextXS>
                        <strong>{candidate?.document_type?.name || '--'}</strong>
                        {': '}
                        {candidate?.document_number || '--'} {candidate?.document_issuing_body}{' '}
                        {candidate?.document_issuing_body_uf?.initials || ''}
                      </TextXS>
                    )}
                    <TextXS>
                      <strong>Sexo:</strong> {candidate?.gender?.name || '--'}
                    </TextXS>
                  </Stack>
                  <Stack w="100%" p={3}>
                    <TextXS>
                      <strong>CEP:</strong> {candidate?.address_zip_code || '--'}
                    </TextXS>
                    <TextXS>
                      <strong>Endereço:</strong> {candidate?.address_street || '--'}
                    </TextXS>
                    <TextXS>
                      <strong>Número:</strong> {candidate?.address_number || '--'}
                    </TextXS>
                    <TextXS>
                      <strong>Complemento: </strong>
                      {candidate?.address_complement || '--'}
                    </TextXS>
                    <TextXS>
                      <strong>Bairro:</strong> {candidate?.address_neighborhood || '--'}
                    </TextXS>
                    <TextXS>
                      <strong>Cidade: </strong>
                      {candidate?.address_city?.name || '--'} / {candidate?.address_state?.initials || '--'}
                    </TextXS>
                    <TextXS>
                      <strong>Telefone:</strong> {candidate?.phone || '--'}
                    </TextXS>
                    <TextXS>
                      <strong>Celular:</strong> {candidate?.cellphone || '--'}
                    </TextXS>
                  </Stack>
                </Flex>
                <Stack p={2}>
                  <TextXS>
                    <strong>ATENÇÃO: </strong>Os dados acima estão incorretos? caso estejam,{' '}
                    <Link
                      onClick={() => {
                        navigate('/painel/meus-dados');
                      }}
                      color="colorLink"
                    >
                      clique aqui
                    </Link>{' '}
                    e atualize seu cadastro.
                  </TextXS>
                </Stack>
              </AccordionTemplate>
              <AccordionTemplate
                title={selectiveProcessData.data?.is_cultural_house ? 'TURMA' : 'VAGA / CARGO DESEJADA'}
                border="1px solid"
                borderColor="primaryColor"
                borderRadius={6}
              >
                <Stack>
                  <Flex
                    display={['flex', 'flex', 'flex', 'grid', 'grid']}
                    gridTemplateColumns={['', '', '', 'repeat(1, 1fr)', 'repeat(1, 1fr)']}
                    justify="center"
                    flexDir={['column', 'column', 'column', 'row', 'row']}
                    w="100%"
                    py={3}
                    gap={3}
                  >
                    {(selectiveProcessData.data?.is_cultural_house && (
                      <VacancyCutureHome
                        selectiveProcessId={selectiveProcessId}
                        culture_houses={selectiveProcessData.data.cultural_houses}
                        isCultureHouse={selectiveProcessData.data.is_cultural_house}
                        hookForms={hookForms}
                        allow_second_registration={selectiveProcessData.data.allow_second_registration}
                      />
                    )) || (
                      <DefaultVacancyForm
                        selectiveProcessId={selectiveProcessId}
                        isFilterVacancyLevel={selectiveProcessData.data?.allow_filter_vacancy_tree}
                        isCultureHouse={selectiveProcessData.data?.is_cultural_house || false}
                        hookForms={hookForms}
                        detailPcd={pcdDetails}
                        onRemovePcdAttachment={(id) => {
                          setAttachToDeleteId(id);
                          modal.onOpen();
                        }}
                        modalityAvailable={selectVacancy?.type_of_competition}
                      />
                    )}
                  </Flex>
                </Stack>
              </AccordionTemplate>
              {selectiveProcessData.data?.firearms_act === 'yes' && (
                <AccordionTemplate
                  border="1px solid"
                  borderColor="primaryColor"
                  borderRadius={6}
                  title="ESTATUTO DO DESARMAMENTO"
                >
                  <Flex flexDir={['column', 'column', 'row', 'row', 'row']}>
                    <Stack w="100%" py={3}>
                      <FormControl>
                        <Checkbox
                          isChecked={hookForms.watch('weapon_carry_permit')}
                          {...hookForms.register('weapon_carry_permit')}
                        >
                          <TextXS>
                            Declaro possuir a documentação de porte de armas e tenho a necessidade de fazer a prova
                            utilizando dessa condição.
                          </TextXS>
                        </Checkbox>
                      </FormControl>
                    </Stack>
                  </Flex>
                </AccordionTemplate>
              )}

              {selectiveProcessData.data?.allows_special_condition && (
                <AccordionTemplate
                  border="1px solid"
                  borderColor="primaryColor"
                  borderRadius={6}
                  title="ATENDIMENTO ESPECIAL"
                >
                  <Flex flexDir={['column', 'column', 'column', 'column', 'column']}>
                    <TextS mb={2} textAlign="left" fontWeight="bold">
                      Você deseja informar alguma condição especial para a realização da prova?
                    </TextS>
                    <Stack align="center" w="100%">
                      <FormControl textAlign="center">
                        <Select {...hookForms.register('has_special_condition')}>
                          <option value="" hidden>
                            Selecione...
                          </option>
                          <option value="yes">Sim</option>
                          <option value="no">Não</option>
                        </Select>
                        {hookForms.formState.errors.has_special_condition && (
                          <MessageError>{hookForms.formState.errors.has_special_condition?.message}</MessageError>
                        )}
                      </FormControl>

                      {hookForms.watch('has_special_condition') === 'yes' && (
                        <CheckboxGroup>
                          <Stack w="100%" gap={0} direction={['column']}>
                            {(selectiveProcessData?.data?.special_condition &&
                              selectiveProcessData?.data?.special_condition.map((condition, index) => (
                                <Stack
                                  key={condition.id}
                                  p={hookForms.watch(`selectedSpecialCondition.${index}`) ? 4 : 1}
                                  transition="0.4s"
                                  bg={hookForms.watch(`selectedSpecialCondition.${index}`) ? 'lightGrey' : 'white'}
                                >
                                  <label htmlFor={`${index}`}>
                                    <input
                                      id={`special-condition-${condition.id}`}
                                      style={{
                                        border: '2px solid #ff0000',
                                        width: '16px',
                                        height: '16px',
                                        marginRight: 7,
                                      }}
                                      type="checkbox"
                                      {...hookForms.register(`selectedSpecialCondition.${index}`)}
                                      value={condition.id}
                                    />
                                    {condition.name}
                                  </label>

                                  {hookForms.watch(`selectedSpecialCondition.${index}`) && (
                                    <Stack borderRadius={10}>
                                      {!condition.is_social_name && (
                                        <Textarea
                                          p={3}
                                          placeholder="Informe com o máximo de detalhes sua condição especial"
                                          {...hookForms.register(`observation.${index}`)}
                                          bg="white"
                                          h="100px"
                                        />
                                      )}

                                      {hookForms.formState.errors.observation && (
                                        <MessageError>
                                          {hookForms.formState?.errors?.observation[index]?.message?.toString()}
                                        </MessageError>
                                      )}

                                      <Stack>
                                        <Flex align="center">
                                          <Text
                                            bg="primaryColor"
                                            color="white"
                                            w="fit-content"
                                            as="label"
                                            htmlFor={`file-${index}`}
                                            py={1.5}
                                            px={3}
                                            borderRadius={5}
                                            cursor="pointer"
                                          >
                                            Selecionar arquivo
                                          </Text>

                                          {renderFilename(index).map((filename, idx) => {
                                            return filename.length < 30 ? (
                                              <TextXS key={idx} ml={4}>
                                                {filename}
                                              </TextXS>
                                            ) : (
                                              <Tooltip key={idx} label={filename}>
                                                <TextXS
                                                  ml={4}
                                                >{`${filename.substring(0, 20)}...${filename.slice(-8)}`}</TextXS>
                                              </Tooltip>
                                            );
                                          })}

                                          <Input
                                            alignContent="center"
                                            {...hookForms.register(`attachmentFile.${index}`)}
                                            type="file"
                                            id={`file-${index}`}
                                            w="fit-content"
                                            pl={0}
                                            border="none"
                                            display="none"
                                            multiple
                                          />
                                          {hookForms.formState.errors.attachmentFile && (
                                            <MessageError ml={2}>
                                              {hookForms.formState?.errors?.attachmentFile[index]?.message?.toString()}
                                            </MessageError>
                                          )}
                                        </Flex>
                                        {registrationData.data?.special_conditions
                                          .filter((sp) => condition.id === sp.id)
                                          .map((attach) => (
                                            <Stack key={attach.id}>
                                              <TableCustom headers={attachSpecialCondition}>
                                                {(attach.attachments?.length > 0 &&
                                                  attach.attachments?.map((files) => (
                                                    <Tr key={files.id} textAlign="center">
                                                      <Td textAlign="center">
                                                        <Link
                                                          fontSize="14px"
                                                          color="colorLink"
                                                          target="_blank"
                                                          href={files.url}
                                                        >
                                                          {files.name}
                                                        </Link>
                                                      </Td>
                                                      <Td textAlign="center">
                                                        <TextXS>{`${files.created_at}`}</TextXS>
                                                      </Td>
                                                      <Td textAlign="center">
                                                        {condition?.has_attachment && attach.attachments.length > 1 ? (
                                                          <TextXS
                                                            cursor={'pointer'}
                                                            onClick={() => deleteAttachment(files.id)}
                                                            color="colorLink"
                                                          >
                                                            Excluir
                                                          </TextXS>
                                                        ) : (
                                                          !condition.has_attachment && (
                                                            <TextXS
                                                              cursor={'pointer'}
                                                              onClick={() => deleteAttachment(files.id)}
                                                              color="colorLink"
                                                            >
                                                              Excluir
                                                            </TextXS>
                                                          )
                                                        )}
                                                      </Td>
                                                    </Tr>
                                                  ))) || (
                                                  <Tr>
                                                    <Td textAlign="center" colSpan={3}>
                                                      Nenhum arquivo enviado!
                                                    </Td>
                                                  </Tr>
                                                )}
                                              </TableCustom>
                                            </Stack>
                                          ))}
                                      </Stack>
                                    </Stack>
                                  )}
                                </Stack>
                              ))) || <MessageError>Sem dados...</MessageError>}
                            <MessageError>
                              {hookForms.formState.errors.selectedSpecialCondition?.root?.message}
                            </MessageError>
                          </Stack>
                        </CheckboxGroup>
                      )}
                    </Stack>
                  </Flex>
                </AccordionTemplate>
              )}

              {selectiveProcessData.data?.protocol && selectiveProcessData.data?.protocol.length > 0 && (
                <AccordionTemplate border="1px solid" borderColor="primaryColor" borderRadius={6} title="PROTOCOLOS">
                  <Flex flexDir={['column', 'column', 'column', 'column', 'column']}>
                    <Stack align="center" w="100%">
                      <CheckboxGroup>
                        <Stack w="100%" gap={0} direction={['column']}>
                          {(selectiveProcessData?.data?.protocol &&
                            selectiveProcessData?.data?.protocol.map((protocol, index) => (
                              <Stack
                                key={protocol.id}
                                p={hookForms.watch(`selectedProtocol.${index}`) ? 4 : 1}
                                transition="0.4s"
                                bg={hookForms.watch(`selectedProtocol.${index}`) ? 'white' : 'white'}
                              >
                                <label htmlFor={`${index}`}>
                                  <input
                                    id={`protocol-${protocol.id}`}
                                    style={{
                                      border: '2px solid #ff0000',
                                      width: '16px',
                                      height: '16px',
                                      marginRight: 7,
                                    }}
                                    type="checkbox"
                                    {...hookForms.register(`selectedProtocol.${index}`)}
                                    value={protocol.id}
                                  />
                                  {protocol.name}
                                </label>

                                {hookForms.watch(`selectedProtocol.${index}`) && (
                                  <Stack borderRadius={10}>
                                    {protocol.is_social_name && (
                                      <Stack>
                                        <FormControl>
                                          <TextXS mb={2}>
                                            O nome social é a forma de tratamento que reflete a identidade de gênero da
                                            pessoa, especialmente importante para pessoas transgênero, travestis e
                                            não-binárias. Esta opção permite que você seja chamado(a) e identificado(a)
                                            pelo nome com o qual se reconhece, respeitando sua identidade.
                                          </TextXS>
                                          <Input
                                            alignContent="center"
                                            placeholder="Nome social"
                                            {...hookForms.register(`social_name_protocol.${index}`)}
                                            bg="white"
                                          />
                                        </FormControl>

                                        {hookForms.formState.errors.social_name_protocol && (
                                          <MessageError>
                                            {hookForms.formState?.errors?.social_name_protocol[
                                              index
                                            ]?.message?.toString()}
                                          </MessageError>
                                        )}
                                      </Stack>
                                    )}

                                    {protocol.max_attached > 0 && (
                                      <>
                                        <Stack>
                                          <Flex justify="center" flexDir={'column'}>
                                            <Flex align="center">
                                              <Text
                                                bg="primaryColor"
                                                color="white"
                                                w="fit-content"
                                                as="label"
                                                htmlFor={`file-attachment-${index}`}
                                                py={1.5}
                                                px={3}
                                                borderRadius={5}
                                                cursor="pointer"
                                              >
                                                Selecionar documentos
                                              </Text>

                                              {renderFilenameProtocol(index).map((filename, idx) =>
                                                filename.length < 30 ? (
                                                  <TextXS key={idx} ml={4}>
                                                    {filename}
                                                  </TextXS>
                                                ) : (
                                                  <Tooltip key={idx} label={filename}>
                                                    <TextXS ml={4}>
                                                      {`${filename.substring(0, 20)}...${filename.slice(-8)}`}
                                                    </TextXS>
                                                  </Tooltip>
                                                ),
                                              )}
                                            </Flex>

                                            <Input
                                              alignContent="center"
                                              {...hookForms.register(`protocol_attachmentFile.${index}`)}
                                              type="file"
                                              id={`file-attachment-${index}`}
                                              w="fit-content"
                                              pl={0}
                                              border="none"
                                              display="none"
                                              multiple
                                            />
                                            {hookForms.formState.errors.protocol_attachmentFile && (
                                              <MessageError ml={2}>
                                                {hookForms.formState?.errors?.protocol_attachmentFile[
                                                  index
                                                ]?.message?.toString()}
                                              </MessageError>
                                            )}
                                          </Flex>

                                          {registrationData.data?.protocol
                                            .filter((sp) => protocol.id === sp.protocol_type.id)
                                            .map((attach) => (
                                              <Stack key={attach.id}>
                                                {attach?.attachments?.map((a) => (
                                                  <Flex gap={2} align={'center'} key={a.id}>
                                                    <Link color="colorLink" target="_blank" href={a.url}>
                                                      <Tooltip label={a?.name}>
                                                        {`${a?.name.substring(0, 20)}...${a.name.slice(-8)}`}
                                                      </Tooltip>
                                                    </Link>
                                                    {attach.attachments.length > 1 && (
                                                      <Box
                                                        cursor="pointer"
                                                        onClick={() => {
                                                          setAttachToDeleteId(a?.id);
                                                          modal.onOpen();
                                                        }}
                                                      >
                                                        <IoTrash fill="red" />
                                                      </Box>
                                                    )}
                                                  </Flex>
                                                ))}
                                              </Stack>
                                            ))}
                                        </Stack>
                                        {protocol.is_social_name && (
                                          <Stack>
                                            <Flex justify="center" flexDir={'column'}>
                                              <Flex align="center">
                                                <Text
                                                  bg="primaryColor"
                                                  color="white"
                                                  w="fit-content"
                                                  as="label"
                                                  htmlFor={`file-photo-${index}`}
                                                  py={1.5}
                                                  px={3}
                                                  borderRadius={5}
                                                  cursor="pointer"
                                                >
                                                  Selecionar foto
                                                </Text>

                                                {renderFilenameProtocolPhoto(index).map((filename, idx) =>
                                                  filename.length < 30 ? (
                                                    <TextXS key={idx} ml={4}>
                                                      {filename}
                                                    </TextXS>
                                                  ) : (
                                                    <Tooltip key={idx} label={filename}>
                                                      <TextXS ml={4}>
                                                        {`${filename.substring(0, 20)}...${filename.slice(-8)}`}
                                                      </TextXS>
                                                    </Tooltip>
                                                  ),
                                                )}
                                              </Flex>

                                              <Input
                                                alignContent="center"
                                                {...hookForms.register(`protocol_photo.${index}`)}
                                                type="file"
                                                id={`file-photo-${index}`}
                                                w="fit-content"
                                                pl={0}
                                                border="none"
                                                display="none"
                                              />
                                              {hookForms.formState.errors.protocol_photo && (
                                                <MessageError ml={2}>
                                                  {hookForms.formState?.errors?.protocol_photo[
                                                    index
                                                  ]?.message?.toString()}
                                                </MessageError>
                                              )}
                                            </Flex>

                                            {registrationData.data?.protocol
                                              .filter((sp) => protocol.id === sp.protocol_type.id)
                                              .map((attach) => (
                                                <Stack key={attach.id}>
                                                  <Flex gap={2}>
                                                    <Link color="colorLink" target="_blank" href={attach?.photo}>
                                                      <Tooltip>{`Foto enviada`}</Tooltip>
                                                    </Link>
                                                  </Flex>
                                                </Stack>
                                              ))}
                                          </Stack>
                                        )}
                                      </>
                                    )}
                                  </Stack>
                                )}
                              </Stack>
                            ))) || <MessageError>Sem dados...</MessageError>}
                          <MessageError>{hookForms.formState.errors.selectedProtocol?.root?.message}</MessageError>
                        </Stack>
                      </CheckboxGroup>
                    </Stack>
                  </Flex>
                </AccordionTemplate>
              )}

              {/* {selectiveProcessData.data?.juror_under_article_440 === 'yes' && (
                <AccordionTemplate border="1px solid" borderColor="primaryColor" borderRadius={6} title="JURADO">
                  <Flex flexDir={['column', 'column', 'row', 'row', 'row']}>
                    <Stack w="100%" py={3}>
                      <TextXS mb={2}>Já foi jurado nos termos do artigo 440 do código de processo penal</TextXS>
                      <Grid w="100%" gridTemplateColumns="repeat(3, 1fr)">
                        <FormControl textAlign="center">
                          <Select
                            value={hookForms.watch('juror_art_440_cpp')}
                            {...hookForms.register('juror_art_440_cpp')}
                          >
                            <option value="" hidden>
                              Selecione...
                            </option>
                            <option value="yes">Sim</option>
                            <option value="no">Não</option>
                          </Select>
                        </FormControl>
                      </Grid>
                      <MessageError>{hookForms.formState.errors.juror_art_440_cpp?.message}</MessageError>
                    </Stack>
                  </Flex>
                </AccordionTemplate>
              )} */}
            </Accordion>
            {!selectiveProcessData?.data?.display_terms_acceptance_before_registration && (
              <Stack mt={2}>
                <Checkbox isChecked={hookForms.watch('terms')} {...hookForms.register('terms')}>
                  <TextXS
                    overflow="auto"
                    dangerouslySetInnerHTML={{
                      __html:
                        selectiveProcessData?.data?.terms_of_use ||
                        'Declaro ter lido e concordado com os termos do edital.',
                    }}
                  />
                </Checkbox>
                <MessageError>{hookForms.formState?.errors.terms?.message}</MessageError>
              </Stack>
            )}

            {selectiveProcessData?.data?.show_eligibility_declaration && (
              <Stack>
                <Checkbox
                  isChecked={hookForms.watch('eligibility_declaration')}
                  {...hookForms.register('eligibility_declaration')}
                >
                  <TextXS
                    overflow="auto"
                    dangerouslySetInnerHTML={{
                      __html: selectiveProcessData?.data?.text_eligibility_declaration || 'Declaração de titulos',
                    }}
                  />
                </Checkbox>
                <MessageError>{hookForms.formState?.errors.eligibility_declaration?.message}</MessageError>
              </Stack>
            )}

            <Stack flexDir="row" justify="flex-end" pb={5}>
              <Button
                w={'100px'}
                onClick={() => {
                  navigate('/painel/inscricoes');
                }}
              >
                Cancelar
              </Button>
              <Button
                isLoading={isPending || updateRegistration.isPending}
                type="submit"
                bg="colorLink"
                color="white"
                w={'100px'}
                _hover={'none'}
              >
                {'Continuar'}
              </Button>
            </Stack>
          </Stack>
        </Flex>
      </MainCard>
      <Modal isOpen={modal.isOpen} onClose={modal.onClose} isCentered>
        <ModalOverlay />
        <ModalContent pb={10} maxW={['80%', '80%', '80%', '40%', '40%']} maxH="none">
          <ModalHeader textAlign="center">Excluir arquivo</ModalHeader>
          <ModalCloseButton />

          <ModalBody display="flex" flexDir="column" gap={1}>
            <Stack>
              <Stack>
                <TextXS color="red.600" fontWeight="bold">
                  Atenção: esta ação é irreversível!
                </TextXS>
                <TextXS>O arquivo enviado esta prestes a ser excluido</TextXS>
              </Stack>

              <Button onClick={() => deleteProtocolAttach(attachToDeletId)} colorScheme="red">
                Excluir arquivo
              </Button>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </FormProvider>
  );
};

export default SelectiveProcessSubscribe;
